import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FullBox } from 'seagull';
import { useResponsive } from '~/client-flow/contexts';
import styles from './OnboardingPage.module.scss';
import { Sidebar } from './Sidebar/Sidebar';
import { StepsContainer } from './Steps/StepsContainer/StepsContainer';
export const COB_MODAL_ROOT_ID = 'cob-modal-root';
export const OnboardingPage = (param)=>{
    let { currentStep, direction, onStepClick, onBack, onNext, relationship, visitedSteps, statement, isStatementAccepted, onStatementChange, isNextDisabled, hideNextButton, hasSignedSuccess } = param;
    const { isMobile } = useResponsive();
    if (isMobile) {
        return /*#__PURE__*/ _jsx(StepsContainer, {
            currentStep: currentStep,
            direction: direction,
            onBack: onBack,
            onNext: onNext,
            relationship: relationship,
            isMobile: true,
            statement: statement,
            isStatementAccepted: isStatementAccepted,
            onStatementChange: onStatementChange,
            isNextDisabled: isNextDisabled,
            hideNextButton: hideNextButton,
            hasSignedSuccess: hasSignedSuccess
        });
    }
    return /*#__PURE__*/ _jsxs(FullBox, {
        flexDirection: "row",
        className: styles.mainLayout,
        id: COB_MODAL_ROOT_ID,
        children: [
            !hasSignedSuccess && /*#__PURE__*/ _jsx("div", {
                className: styles.sidebar,
                children: /*#__PURE__*/ _jsx(Sidebar, {
                    currentStep: currentStep,
                    onStepClick: onStepClick,
                    relationship: relationship,
                    visitedSteps: visitedSteps
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "".concat(styles.steps, " ").concat(hasSignedSuccess ? styles.stepsSignedSuccess : ''),
                children: /*#__PURE__*/ _jsx(StepsContainer, {
                    currentStep: currentStep,
                    direction: direction,
                    onBack: onBack,
                    onNext: onNext,
                    relationship: relationship,
                    statement: statement,
                    isStatementAccepted: isStatementAccepted,
                    onStatementChange: onStatementChange,
                    isNextDisabled: isNextDisabled,
                    hideNextButton: hideNextButton,
                    hasSignedSuccess: hasSignedSuccess
                })
            })
        ]
    });
};
